/**
 * Pages where the Report an Issue widget does NOT capture the screen by
 * default (ISS-485 privacy). The capture is on by default everywhere else,
 * and a report image can be read by triage staff; on these pages the screen
 * is likely to show pay, time-off, personnel or candidate data. The user can
 * still switch the capture on deliberately.
 */
const SENSITIVE_PREFIXES = ['/hr', '/time', '/recruiting'];
const SENSITIVE_WORDS = /payroll|timesheet|\bpto\b|compensation|salary/i;

export function isSensitiveReportRoute(pathname: string): boolean {
  const path = pathname.toLowerCase();
  return (
    SENSITIVE_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`)) || SENSITIVE_WORDS.test(path)
  );
}
